import { LAYOUT, THEME } from 'reactor/common';

const { COLOR, OFFSET, UNIT } = THEME;

export default {
  actions: {
    backgroundColor: 'rgba(255,255,255,0.75)',
    width: '100%',
    position: 'absolute',
    bottom: 0,

    display: 'flex',
    flexDirection: 'row',
    marginTop: OFFSET,
    justifyContent: 'space-between',
    zIndex: 1,
  },

  actionSeparator: {
    flex: 1,
  },

  dialogForm: {
    paddingTop: OFFSET,
    paddingBottom: OFFSET * 2 + UNIT,
    maxHeight: '70vh',
  },

  FORM_CONTENT: {
    backgroundColor: COLOR.WHITE,
    paddingVertical: UNIT,
    paddingHorizontal: OFFSET,
  },

  FORM_CONTENT_LANDSCAPE: {
    ...LAYOUT.STYLE.SHADOW,
    marginBottom: OFFSET,
  },
};
